export const BUSINESS_DAY_KEYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const BUSINESS_DAY_LABELS_AR = {
  sunday: "الأحد",
  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
};

export const DEFAULT_CLOSED_MESSAGE_AR =
  "المتجر مغلق حالياً — يمكنك تصفح المنتجات، الطلب متاح خلال أوقات الدوام فقط.";

export function defaultBusinessHoursSchedule() {
  const days = {};
  for (const key of BUSINESS_DAY_KEYS) {
    days[key] = { enabled: true, open: "09:00", close: "22:00" };
  }
  return {
    days,
    closed_message_ar: DEFAULT_CLOSED_MESSAGE_AR,
  };
}

export function normalizeBusinessHours(raw) {
  if (!raw || typeof raw !== "object") return defaultBusinessHoursSchedule();
  const daysIn = raw.days && typeof raw.days === "object" ? raw.days : {};
  const days = {};
  for (const key of BUSINESS_DAY_KEYS) {
    const row = daysIn[key] || {};
    days[key] = {
      enabled: row.enabled !== false && row.enabled !== 0 && String(row.enabled).toLowerCase() !== "false",
      open: String(row.open || "09:00").slice(0, 5),
      close: String(row.close || "22:00").slice(0, 5),
    };
  }
  return {
    days,
    closed_message_ar: String(raw.closed_message_ar || DEFAULT_CLOSED_MESSAGE_AR).trim() || DEFAULT_CLOSED_MESSAGE_AR,
  };
}

function parseHm(value) {
  const parts = String(value || "").trim().split(":");
  const h = Number(parts[0]);
  const m = Number(parts[1] || 0);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
}

/** JS Date.getDay(): 0 = Sunday … 6 = Saturday */
export function isStoreOpenNow(schedule, now = new Date()) {
  const normalized = normalizeBusinessHours(schedule);
  const dayKey = BUSINESS_DAY_KEYS[now.getDay()];
  const day = normalized.days[dayKey];
  if (!day?.enabled) return false;

  const openM = parseHm(day.open);
  const closeM = parseHm(day.close);
  const nowM = now.getHours() * 60 + now.getMinutes();
  if (openM == null || closeM == null) return false;
  if (openM === closeM) return false;

  if (closeM < openM) {
    return nowM >= openM || nowM < closeM;
  }
  return nowM >= openM && nowM < closeM;
}

export function formatTodayHoursLabel(schedule, language = "ar") {
  const normalized = normalizeBusinessHours(schedule);
  const dayKey = BUSINESS_DAY_KEYS[new Date().getDay()];
  const day = normalized.days[dayKey];
  if (!day?.enabled) {
    return language === "ar" ? "مغلق اليوم" : "Closed today";
  }
  return language === "ar"
    ? `اليوم: ${day.open} – ${day.close}`
    : `Today: ${day.open} – ${day.close}`;
}
